import { Address } from './address';
import { Program } from './program';
import { RestrictedItem } from './restrictedItem';

export interface OrderEntry {
  sfaOrderId?: number;
  customerNumber?: number;
  orderType?: string;
  orderTypeDescription?: string;
  reference?: string;
  vendorOrderNo?: string;

  shipToName?: string;
  shipToState?: string;
  shipToZip?: number;
  warehouseCode?: string;
  stage?: string;
  requiredShipDate?: Date;
  promisedDate?: Date;
  shippedDate?: Date;
  createDate?: Date;
  total?: number;
  totalShipped?: number;
  totalInvoiced?: number;
  onHold?: boolean;
  trackingNumber?: string;
  subtotal?: number;
  discount?: number;

  sfaOrderItems: OrderItem[];
  sfaOrderNotes: SFAOrderNote[];
  isOpenOrderEdit: boolean;
  orderNumber?: number;
  orderSuffix?: number;
  isCustomAddress?: boolean;
  restrictedItems?: RestrictedItem[];
  totalTax?: number;
  totalFreight?: number;
  orderWeight?: number;
  isShowOrder?: boolean;
  approvalSubmittedDate?: Date;
  submitDate?: Date;
  sourcepros?: string; //Source of order can be blank or Split, EDI, CC, SF

  //Order header ******
  //dropdowns
  termCode?: string;
  termsType?: string;
  shipToNumber?: string; //if custom this string will equal 'custom'
  orderQuote?: string;
  carrier?: string;

  //text box
  customerPO?: string;
  orderedBy?: string;
  note?: string;

  //check box
  quotePresented: boolean;
  printNote: boolean;
  freight: boolean;
  quoteLost: boolean;
  allowBackorder: boolean;
  shipComplete: boolean;

  customShipToAddress?: Address;
  //////////

  programId?: number;
  program: Program;

  virtualShowIdAndName?: string;
  userEditing?: string;
}

export function isOrderEntry(arg: any): arg is OrderEntry {
  return arg && arg.sfaOrderId;
}

export const initialOrder: OrderEntry = {
  sfaOrderId: undefined,
  sfaOrderItems: [],
  sfaOrderNotes: [],
  isOpenOrderEdit: false,
  quotePresented: false,
  printNote: false,
  freight: false,
  quoteLost: false,
  allowBackorder: false,
  shipComplete: false,
  program: null,
  userEditing: '',
};

export interface OrderItem {
  sfaOrderItemId?: number;
  orderNumber?: number;
  orderSuffix?: number;
  itemNumber?: string;
  bfgShortSku?: string;
  itemName?: string;
  description1?: string;
  description2?: string;
  lineNumber?: number;
  quantity?: number;
  unitOfMeasure?: string;
  originalCustomerPrice?: number;
  overrideCost?: number;
  overrideSource?: string;
  overrideDate?: string;
  price?: number;
  listPrice?: number;
  total?: number;
  shipDate?: Date;
  earlyShipDate?: Date;
  standardCost?: number;
  selected?: boolean;
  isCustomItem?: boolean;
  vendorNumber?: number;
  extendedPrice?: number;
  priceSource?: string;
  images?: string[];
  margin?: number;
  segment?: string;
  customerPrice?: number;
  isLocked?: boolean;
  pcat?: string;
  approvedPrice?: number;
  availability?: string[];
  promisedDate?: Date;
  qtyShipped?: number;
  qtyBackorder?: number;
  freightExtra?: number;
  freightExtraQtyBreak?: number;
}

export interface SFAOrderNote {
  sFAOrderNoteId: number;
  sFAOrderId: number;
  note: string;
  createDate?: string;
  lastEditDate?: string;
  printAck: boolean;
  printPickTicket: boolean;
  printInvoice: boolean;
  isLocked: boolean;
  pageNo: number;
  selected?: boolean;
  inEdit?: boolean;
  deleted: boolean;
}
